import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'alumni-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './alumni-menu.component.html',
  styleUrls: ['./alumni-menu.component.css'],
})
export class AlumniMenuComponent {

}
